__turbopack_context__.v({
  "offerHistoryContainer": "_0w-w_W_offerHistoryContainer",
  "offerHistoryProgressBarContainer": "_0w-w_W_offerHistoryProgressBarContainer",
  "offerHistoryValues": "_0w-w_W_offerHistoryValues",
  "offerHistoryValuesCaption": "_0w-w_W_offerHistoryValuesCaption",
  "offerHistoryValuesContainer": "_0w-w_W_offerHistoryValuesContainer",
});
